import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, ExternalLinkIcon, StarIcon, CheckSquareIcon, PenIcon } from 'lucide-react';
import { ArticleCardProps, ToolCardProps, VendorCardProps, ChecklistItemProps } from './types';
import { useDarkMode } from '../../../context/DarkModeContext';
export const ArticleCard = ({
  title,
  excerpt,
  author,
  date,
  readTime,
  category
}: ArticleCardProps) => {
  const {
    darkMode
  } = useDarkMode();
  return <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} rounded-lg shadow-sm border overflow-hidden hover:shadow-md transition-shadow`} data-id="element-15902" data-mp="vlt40tkwg64l">
      <div className="p-5" data-id="element-15903" data-mp="lndkbbo7bz54">
        <div className="flex items-center mb-3" data-id="element-15904" data-mp="lo54lqccmag3">
          <span className={`px-2.5 py-0.5 ${darkMode ? 'bg-indigo-900/50 text-indigo-300' : 'bg-indigo-100 text-indigo-800'} text-xs font-medium rounded-full`} data-id="element-15905" data-mp="lpg8dq5sni77">
            {category}
          </span>
          <span className={`ml-2 text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-15906" data-mp="30zynqxjca24z">
            {date}
          </span>
        </div>
        <h3 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'} mb-2`} data-id="element-15907" data-mp="35y0hccee5jup">
          {title}
        </h3>
        <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} text-sm mb-4`} data-id="element-15908" data-mp="2w02thq0g1p2m">
          {excerpt}
        </p>
        <div className="flex items-center justify-between" data-id="element-15909" data-mp="2i7mpalvt3l04">
          <div className="flex items-center" data-id="element-15910" data-mp="2n0futbz3mxd9">
            <div className="text-xs" data-id="element-15911" data-mp="2n18s7mc64aiq">
              <p className={`${darkMode ? 'text-gray-200' : 'text-gray-900'} font-medium`} data-id="element-15912" data-mp="28b9x5sfwtf7h">
                {author}
              </p>
              <p className={`${darkMode ? 'text-gray-500' : 'text-gray-500'}`} data-id="element-15913" data-mp="2d80a46wf3uoo">
                {readTime}
              </p>
            </div>
          </div>
          <button className={`${darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-600 hover:text-indigo-700'} text-sm font-medium flex items-center`} data-id="element-15914" data-mp="23c6si93udb01">
            Read article
            <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-15915" data-mp="51psstba7byd" />
          </button>
        </div>
      </div>
    </div>;
};
export const ToolCard = ({
  name,
  description,
  category,
  pricing,
  link,
  icon
}: ToolCardProps) => {
  const {
    darkMode
  } = useDarkMode();
  return <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} rounded-lg shadow-sm border overflow-hidden hover:shadow-md transition-shadow`} data-id="element-15916" data-mp="ssbzag5n0o69">
      <div className="p-5" data-id="element-15917" data-mp="itmikqph99rl">
        <div className="flex items-center justify-between mb-3" data-id="element-15918" data-mp="isur9s2wxy74">
          <div className="flex items-center" data-id="element-15919" data-mp="esknmm2lfjvf">
            <div className={`h-8 w-8 rounded-md ${darkMode ? 'bg-indigo-900/50 text-indigo-400' : 'bg-indigo-100 text-indigo-600'} flex items-center justify-center mr-3`} data-id="element-15920" data-mp="errdrc8c8e92">
              {icon}
            </div>
            <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-15921" data-mp="1f0hf620jxrtt">
              {name}
            </h3>
          </div>
          <span className={`px-2.5 py-0.5 ${darkMode ? 'bg-blue-900/50 text-blue-300' : 'bg-blue-100 text-blue-800'} text-xs font-medium rounded-full`} data-id="element-15922" data-mp="1j2cc6ubg9j1s">
            {category}
          </span>
        </div>
        <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} text-sm mb-4`} data-id="element-15923" data-mp="1xqz2fr2m7v7s">
          {description}
        </p>
        <div className="flex items-center justify-between" data-id="element-15924" data-mp="22p0o8jrfe8my">
          <span className={`text-xs font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-15925" data-mp="26rng2ko3jtk5">
            {pricing}
          </span>
          <Link to={link} className={`${darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-600 hover:text-indigo-700'} text-sm font-medium flex items-center`} data-id="element-15926" data-mp="2bpyt149ouk6l">
            Learn more
            <ExternalLinkIcon className="h-3 w-3 ml-1" data-id="element-15927" data-mp="3i7y8jlc29kzd" />
          </Link>
        </div>
      </div>
    </div>;
};
export const VendorCard = ({
  name,
  specialty,
  experience,
  price,
  rating
}: VendorCardProps) => {
  const {
    darkMode
  } = useDarkMode();
  return <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} rounded-lg shadow-sm border overflow-hidden hover:shadow-md transition-shadow`} data-id="element-15928" data-mp="3s5colju2o7r5">
      <div className="p-5" data-id="element-15929" data-mp="2zhynd9jccq18">
        <div className="flex justify-between items-start mb-3" data-id="element-15930" data-mp="2zf43pk85j98v">
          <h3 className={`font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-15931" data-mp="2ujovb7swy5ju">
            {name}
          </h3>
          <div className="flex" data-id="element-15932" data-mp="34gjrvl5mlvvh">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < rating ? 'text-amber-400' : 'text-gray-300'}`} fill={i < rating ? 'currentColor' : 'none'} data-id="element-15933" data-mp="34egrq8aremd1" data-mpi={i} />)}
          </div>
        </div>
        <p className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'} mb-3`} data-id="element-15934" data-mp="r8sj12nwb319">
          <span className={`font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-15935" data-mp="w1ljvfg8tr82">
            Specialty:
          </span>{' '}
          {specialty}
        </p>
        <p className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'} mb-3`} data-id="element-15936" data-mp="mbscyrr1q0a5">
          <span className={`font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-15937" data-mp="1a1mnv3rt1err">
            Experience:
          </span>{' '}
          {experience}
        </p>
        <div className="flex items-center justify-between" data-id="element-15938" data-mp="10yljb7il7vq7">
          <span className={`text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-15939" data-mp="1518cpcuwpopi">
            {price}
          </span>
          <button className={`${darkMode ? 'text-indigo-400 hover:text-indigo-300' : 'text-indigo-600 hover:text-indigo-700'} text-sm font-medium flex items-center`} data-id="element-15940" data-mp="3loaxrjfdpfid">
            View profile
            <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-15941" data-mp="1watd8po36wux" />
          </button>
        </div>
      </div>
    </div>;
};
export const ChecklistItem = ({
  title,
  description,
  status
}: ChecklistItemProps) => {
  const {
    darkMode
  } = useDarkMode();
  let borderClass = '';
  let bgClass = '';
  let iconBgClass = '';
  let titleClass = '';
  let descClass = '';
  if (status === 'complete') {
    borderClass = 'border-green-500';
    bgClass = darkMode ? 'bg-green-900/20' : 'bg-green-50';
    iconBgClass = 'bg-green-500 text-white';
    titleClass = darkMode ? 'text-green-400' : 'text-green-800';
    descClass = darkMode ? 'text-green-300' : 'text-green-700';
  } else if (status === 'current') {
    borderClass = 'border-blue-500';
    bgClass = darkMode ? 'bg-blue-900/20' : 'bg-blue-50';
    iconBgClass = 'bg-blue-500 text-white';
    titleClass = darkMode ? 'text-blue-400' : 'text-blue-800';
    descClass = darkMode ? 'text-blue-300' : 'text-blue-700';
  } else {
    borderClass = darkMode ? 'border-gray-600' : 'border-gray-300';
    bgClass = darkMode ? 'bg-gray-800' : 'bg-white';
    iconBgClass = darkMode ? 'bg-gray-700 border border-gray-600 text-transparent' : 'bg-white border border-gray-300 text-transparent';
    titleClass = darkMode ? 'text-gray-200' : 'text-gray-700';
    descClass = darkMode ? 'text-gray-400' : 'text-gray-600';
  }
  return <div className={`p-4 border-l-4 rounded-r-lg mb-4 flex items-start ${borderClass} ${bgClass}`} data-id="element-15942" data-mp="2ii76hq7dtd4c">
      <div className={`h-6 w-6 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5 ${iconBgClass}`} data-id="element-15943" data-mp="2mj9aslg5ofd6">
        {status === 'complete' && <CheckSquareIcon className="h-4 w-4" data-id="element-15944" data-mp="2whgei2lfp0x8" />}
        {status === 'current' && <PenIcon className="h-3 w-3" data-id="element-15945" data-mp="2wekiijt5cmbf" />}
      </div>
      <div data-id="element-15946" data-mp="6qtingbgir4m">
        <h4 className={`font-medium ${titleClass}`} data-id="element-15947" data-mp="6r39f64bt2bd">{title}</h4>
        <p className={`text-sm mt-1 ${descClass}`} data-id="element-15948" data-mp="bpwpn6azz7f8">{description}</p>
      </div>
    </div>;
};